<template>
  <div>
    <div class="action-buttons">
      <div class="left-buttons">
        <div class="form-group mar-rt-10" style="max-width: 230px;">
          <label>{{ $t('gestiune.locatie') }}</label>
          <select class="form-control" v-model="selectedVatNumber">
            <option :value="null">Selectează</option>
            <option
              v-for="group in groupedLocations"
              :key="group.vat"
              :value="group.vat"
            >
              VAT: {{ group.vat }} — {{ group.locations.map(l => l.name).join(', ') }}
            </option>
          </select>
        </div>
        <div class="form-group mar-rt-10" style="max-width: 230px;">
            <label for="searchInput">{{ $t('gestiune.searchClients') }}</label>
            <el-input
                id="searchInput"
                v-model="searchQuery"
                placeholder="Caută după nume de client"
                clearable
            ></el-input>
        </div>
        <div class="search-button-reports">
          <button
              :title="$t('reports.search')"
              class="btn add mar-rt-10"
              @click="onSearch"
          >
              <i class="ti-search"></i>
              <span>{{ $t('general.search') }}</span>
          </button>
        </div>
       </div>
       <div class="right-buttons">
          <button class="btn add mar-rt-10"  @click.prevent="openAddClientModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{ $t('gestiune.addClient') }}
          </button>
       </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
      <div class="data-table">
          <el-table :data="filteredClients" :empty-text="$t('gestiune.noData')">
              <el-table-column prop="clientName" :label="$t('gestiune.clientName')"></el-table-column>
              <el-table-column prop="address" :label="$t('gestiune.address')"></el-table-column>
              <el-table-column prop="city" :label="$t('gestiune.city')"></el-table-column>
              <el-table-column prop="countries" :label="$t('gestiune.countries')"></el-table-column>
              <el-table-column prop="cui" :label="$t('gestiune.cui')"></el-table-column>
              <el-table-column :label="$t('marketingOffers.actions')" width="100">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end">
                    <!-- Trigger: săgeată jos cu stil -->
                    <span class="arrow-box">
                      &#9662;
                    </span>

                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">

                      <el-dropdown-item @click.native="editRow(scope.row)">
                        {{$t('general.edit')}}
                      </el-dropdown-item>

                      <el-dropdown-item @click.native="handleDelete(scope.row.id)"
                        style="color: red; font-weight: bold;">
                        {{$t('general.delete')}}
                      </el-dropdown-item>

                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
          </el-table>
          <el-pagination
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
            style="margin-top: 15px; text-align: right;"
          ></el-pagination>
      </div>
      </div>
   </div>

   <ManagementClientsAdd
      :groupedLocations="groupedLocations"
      :getClients="getClients"
      :clientData="client"
      :editMode="editMode"
      @getClients="getClients"
    />
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  import ManagementClientsAdd from './ManagementClientsAdd.vue'

  export default {
    components: {
      ManagementClientsAdd
    },
    data () {
      return {
        loading: false,
        loadingTimeout: null,
        totalItems: 0,
        currentPage: 1,
        pageSize: 20,
        selectedVatNumber: null,
        selectedLocationId: '',
        selectedLocation: null,
        vatNumber: null,
        tableData: [],
        editMode: false,
        client: {
          companyName: '',
          abbreviation: '',
          CUI: '',
          registrationNumber: '',
          address: '',
          city: '',
          countries: '',
          bank: '',
          IBAN: '',
          dueDays: null
        },
        searchQuery: ''
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      }
    },
    watch: {
      selectedLocationId (id) {
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            break
          }
        }
      },
      selectedVatNumber (newVat) {
        this.selectedVatNumber = newVat
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
    },
    computed: {
      filteredClients () {
        if (!this.searchQuery) {
          return this.tableData
        }

        return this.tableData.filter(client => {
          return client.clientName.toLowerCase().includes(this.searchQuery.toLowerCase())
        })
      }
    },
    methods: {
      onSearch () {
        // Validare cod TVA (dacă e obligatoriu)
        if (!this.selectedVatNumber) {
          swal({
            type: 'warning',
            title: this.$t('general.required'),
            text: 'Selectateaza locatiați după cod TVA',
            confirmButtonText: 'OK'
          })

          this.tableData = []
          this.totalItems = 0
          this.currentPage = 1
          return
        }

        // Apelăm fetch-ul efectiv
        this.getClients()
      },
      openAddClientModal () {
        this.editMode = false
        this.client = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          city: '',
          countries: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addClientModal')
      },
      handlePageChange (page) {
        this.currentPage = page
        this.getClients(this.currentPage, this.pageSize)
      },
      mapCustomerRowToForm (row = {}) {
        return {
          companyName: row.clientName || row.companyName || row.name || '',
          abbreviation: row.abbreviation || '',
          CUI: row.vatNumber || row.cui || row.customerVatNumber || '',
          email: row.email || '',
          registrationNumber: row.registrationNumber || '',
          address: row.address || '',
          city: row.city || '',
          countries: row.countries || '',
          bank: row.bank || '',
          IBAN: row.IBAN || row.iban || '',
          dueDays: row.dueDays != null ? row.dueDays : null,
          id: row.id || row._id || null,
          _rev: row._rev || null,
          externalLocationId: row.externalLocationId || null
        }
      },
      editRow (row) {
        this.editMode = true
        this.client = this.mapCustomerRowToForm(row)
        this.$modal.show('addClientModal')
      },
      async getClients (page = 1, pageSize = 25) {
        this.tableData = []
        this.totalItems = 0
        this.currentPage = 1

        try {
          if (!this.companyID) {
            console.error('Company ID is missing')
            return
          }

          if (!this.selectedVatNumber) {
            console.warn('VAT number is missing. Skipping product fetch.')
            return
          }

          swal({
            title: 'Se încarcă...',
            text: 'Așteaptă încărcarea datelor',
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading()
            }
          })

          clearTimeout(this.loadingTimeout)
          this.loadingTimeout = setTimeout(() => {
            this.loading = true
          }, 100)

          let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/customers?externalCompanyId=${this.companyID}&page=${page}&limit=${pageSize}`

          if (this.selectedVatNumber) {
            url += `&vatNumber=${encodeURIComponent(this.selectedVatNumber)}`
          }

          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })

          if (!response.ok) {
            throw new Error('Error fetching clients')
          }

          const data = await response.json()
          if (!data.customers || !Array.isArray(data.customers)) {
            throw new Error('Invalid data format: customers not found')
          }

          clearTimeout(this.loadingTimeout)
          this.loading = false
          this.totalItems = data.total || 0
          this.currentPage = data.currentPage || page
          this.pageSize = data.pageSize || pageSize

          this.tableData = data.customers.map(client => ({
            id: client._id,
            _rev: client._rev,
            clientName: client.name || '',
            abbreviation: client.abbreviation || '',
            registrationNumber: client.registrationNumber || '',
            address: client.address || '',
            city: client.city || '',
            countries: client.countries || '',
            bank: client.bank || '',
            IBAN: client.IBAN || client.iban || '',
            dueDays: client.dueDays != null ? client.dueDays : null,
            cui: client.customerVatNumber || client.vatNumber || '',
            vatNumber: client.customerVatNumber || client.vatNumber || '',
            email: client.email || '',
            externalLocationId: client.externalLocationId || null
          }))

          swal.close()
        } catch (error) {
          swal.close()

          console.error('Error fetching clients:', error)
        }
      },
      async handleDelete (id) {
        if (!id) {
          console.error('Missing product ID for deletion.')
          return
        }

        const confirm = await swal({
          title: 'Ești sigur?',
          text: 'Clientul va fi șters definitiv.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Da, șterge',
          cancelButtonText: 'Anulează'
        })

        if (!confirm) return

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              type: 'customer',
              id: id,
              externalCompanyId: this.companyID
            })
          })

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

          const data = await response.json()
          console.log('Client deleted successfully:', data)

          swal({
            title: 'Succes',
            text: 'Clientul a fost șters cu succes.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.getClients()
        } catch (error) {
          console.error('Error deleting client:', error)

          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la ștergerea clientului.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    }
  }
</script>

<style scoped>
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}
.el-pagination {
  text-align: center !important;
}
.left-buttons {
  display: flex;
  align-items: center;
}
.search {
display: flex;
flex-direction: column;
}
.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/ManagementClients.vue